import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap5";
import { camelCase } from "change-case";

export default class extends Controller {
  static values = {
    title: String,
    price: Number,
    plays: Number,
    packageName: String,
    message: String,
  };

  static targets = [
    "title",
    "submitButton",
    "price",
    "plays",
    "packageName",
    "message",
    "btn",
    "wbtn"
  ];

  initialize() {
    console.log("INIT")
    this.boundOnModalShow = this.onModalShow.bind(this);
    this.boundDispose = this.dispose.bind(this);
  }

  connect() {
    console.log("YO!", this.element)
    this.element.addEventListener("show.bs.modal", this.boundOnModalShow);

    this.modalInst = Modal.getOrCreateInstance(this.element);
    this.element.addEventListener("hidden.bs.modal", this.boundDispose);
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal",  this.boundOnModalShow);
    this.element.removeEventListener("hidden.bs.modal", this.boundDispose);
  }

  dispose() {
    this.modalInst.dispose();
  }

  onModalShow(event) {

    console.log('values!',this.songValue)

    // Button that triggered the modal
    var button = event.relatedTarget;
    // Extract info from data-* attributes

    for (const name in button.dataset) {
      console.log(name, button.dataset[name]);
      var nameMatch = /^manageSubModal(\w+Value)$/.exec(name);
      //console.log(nameMatch);
      if (nameMatch && nameMatch[1]) {
        const value = button.dataset[nameMatch[0]];
        // console.log("SET:", camelCase(nameMatch[1]), value);
        this[camelCase(nameMatch[1])] = value;
      }
    }
  }

  submitForm() {
    $(this.btnTargets).addClass("d-none");
    $(this.wbtnTarget).removeClass("d-none");
    
    $("#subscription_amount").val(this.priceValue);
    $("#subscription_form")[0].requestSubmit();
  }

  titleValueChanged() {
    // console.log("songNameValueChanged", this.songNameValue);
    //var modalBodyTitle = this.element.querySelector(".modal-body .song-title");

    // modalTitle.textContent = 'Manage ' + recipient
    this.titleTarget.textContent = this.titleValue;
    this.submitButtonTarget.textContent = this.titleValue;
  }

  messageValueChanged() {
    this.messageTarget.textContent = this.messageValue;
  }

  packageNameValueChanged() {
    this.packageNameTarget.textContent = this.packageNameValue;
  }

  priceValueChanged() {
    this.priceTarget.textContent = this.priceValue;
  }
  playsValueChanged() {
    this.playsTarget.textContent = this.playsValue;
  }
}
